export const pl = {
    common: {
        PIN_CODE_LABEL: 'KOD PIN',
        USER_NAME_LABEL: 'Imię i nazwisko',
        comment: 'Komentarz',
        year: 'Rok',
        configuration: 'Konfiguracja',
        cancel: 'Anuluj',
        search: 'Szukaj',
        remove: 'Usuń',
        confirmationDialogTitle: 'Czy chcesz usunąć tę pozycję?',
        selectDate: 'Wybierz datę',
        select: 'Wybierz',
        notFound: 'Nie znaleziono',
        equipmentPickerPlaceholder: 'Obiekt wyposażenia...',
        searchPlaceholder: 'Szukaj...',
        equipmentTypePickerPlaceholder: 'Typ wyposażenia',
        equipmentTypePickerTitle: 'Wybierz typ wyposażenia',
        emptyTableMessage: 'Brak danych',
        flowPikcerTitle: 'Wybierz przepływ',
        selectIcon: 'Wybierz ikonę',
        locationPickerTitle: 'Wybierz lokalizację',
        locationPlaceholder: 'Lokalizacja...',
        noSublocations: 'Brak lokalizacji podrzędnych',
        locationsTitle: 'Lokalizacje',
        edit: 'Edytuj',
        save: 'Zapisz',
        added: 'Dodano',
        updated: 'Zaktualizowano',
        add: 'Dodaj',
        removed: 'Usunięto',
        reload: 'Odśwież',
        confirm: 'Potwierdź',
        rollBack: 'Przywróć',
        images: 'Zdjęcia',
        documents: 'Dokumenty',
        download: 'Pobierz',
        saved: 'Zapisano',
        date: 'Data',
        hour: 'Godzina',
        preview: 'Podgląd',
        data: 'Dane',
        attributes: 'Cechy',
        checkList: 'Lista kontrolna',
        name: 'Nazwa',
        type: 'Typ',
        status: 'Status',
        designation: 'Oznaczenie',
        symbol: 'Symbol',
        serialNumber: 'Nr fabryczny',
        registryNumber: 'Nr ewidencyjny',
        machineNumber: 'Nr maszyny',
        udtNumber: 'Nr UDT',
        manufacturedYear: 'Rok produkcji',
        manufacturer: 'Producent',
        supplier: 'Dostawca',
        mainSupplier: 'Główny dostawca',
        attribute: 'Cecha',
        nameRequired: 'Nazwa jest wymagana',
        yearGreaterThan: 'Rok musi być większy niż',
        location: 'Lokalizacja',
        fieldRequired: 'To pole jest wymagane',
        description: 'Opis',
        minimumQuantity: 'Minimalna ilość',
        optimalQuantity: 'Optymalna ilość',
        priority: 'Ważność (priorytet)',
        formatYYYY: 'Format YYYY',
        storageQuantity: 'Stan magazynowy',
        quantity: 'Ilość',
        quantityGreaterThan: 'Ilość musi być większa niż',
        machine: 'Maszyna',
        tool: 'Narzędzie',
        order: 'Kolejność',
        required: 'Wymagany',
        dateFormat: 'Format daty',
        selectDictionary: 'Wybierz słownik',
        selectDictionaryValue: 'Wybierz wartość słownika',
        return: 'Powrót',
        parameters: 'Parametry',
        editCategory: 'Edytuj kategorię',
        addCategory: 'Dodaj nową kategorię',
        changeColor: 'Zmień kolor',
        noColor: 'Brak koloru',
        shift: 'Zmiana',
        start: 'Początek',
        end: 'Koniec',
        shiftSchema: 'Schemat zmiany',
        shifts: 'Zmiany',
        dictionary: 'Słownik',
        subEntries: 'Wpisy podrzędne',
        key: 'Klucz',
        value: 'Wartość',
        moveUp: 'Przenieś w górę',
        moveDown: 'Przenieś w dół',
        addLocation: 'Dodaj nową lokalizację',
        editLocation: 'Edytuj lokalizację',
        companiesDatabase: 'Baza firm',
        flows: 'Przepływy',
        read: 'Oczyt',
        write: 'Zapis',
        noImage: 'Brak zdjęcia',
        email: 'E-mail',
        function: 'Funkcja',
        active: 'Aktywne',
        notActive: 'Nie aktywowane',
        disabled: 'Zablokowane',
        entryNumber: 'Numer wpisu',
        issuedDate: 'Data uzyskania',
        expiresDate: 'Data ważności',
        move: 'Przenieś',
        separateForm: 'Oddziel z',
        separate: 'Oddziel',
        warehouse: 'Magazyn',
        actions: 'Akcje',
        putInCurrentLocation: 'Umieść w bieżącej lokalizacji',
        selectLocationFormRightMenu: 'Wybierz lokalizację w prawym menu',
        showUnassignedItems: ' Wyświetl nieprzypisane przedmioty',
        separated: 'Oddzielono',
        moved: 'Przeniesiono',
        categories: 'Kategorie',
        welcome: 'Witaj',
        loginToSignaloCMMS: 'Zaloguj się do Signalo CMMS',
        login: 'Zaloguj się',
        loginByEmailAndPassword: 'Zaloguj się za pomocą adresu e-mail i hasła',
        loginByCode: 'Zaloguj się za pomocą kodu',
        accessCode: 'Kod dostępu',
        enterEmail: 'Wpisz email',
        enterPassword: 'Wpisz hasło',
        enterCode: 'Wpisz kod dostępu',
        userNotFound: 'Nie znaleziono użytkownika',
        userNotActivated: 'Użytkownik nie został aktywowany',
        userDisabled: 'Użytkownik zablokowany',
        wrongPassword: 'Złe hasło',
        locations: 'Lokalizacje',
        pageNotFound: 'Nie znaleziono strony',
        group: 'Grupa',
        yes: 'Tak',
        no: 'Nie',
        hourlyCost: 'Koszt roboczogodziny',
        price: 'Cena',
        newEntry: 'Nowy wpis',
        predictedFinishTime: 'Spodziewany czas realizacji',
        ok: 'Ok',
        archive: 'Archiwizuj',
        costs: 'Koszta',
        companyManagement: 'Zarządzanie firmą',
        companyData: 'Dane firmy',
        supportedLanguages: 'Dostępne języki',
        en: 'Angielski',
        pl: 'Polski',
        es: 'Hiszpański',
        de: 'Niemiecki',
        it: 'Włoski',
        fr: 'Francuski',
        ru: 'Rosyjski',
        uk: 'Ukraiński',
        pt: 'Portugalski',
        nl: 'Niderlandzki',
        tr: 'Turecki',
        sr: 'Serbski',
        defaultLanguage: 'Domyślny język',
        companyLogo: 'Logo firmy',
        notificationsManagement: 'Zarządzanie powiadomieniami',
        category: 'Kategoria',
        today: 'Dziś',
        month: 'Miesiąc',
        week: 'Tydzień',
        day: 'Dzień',
        close: 'Zamknij',
        show: 'Wyświetl',
        rollBackFormalConfirmation: 'Anuluj formalne potwierdzenie',
        signUp: 'Zarejestruj się',
        nameSurname: '@:common.USER_NAME_LABEL',
        users_name_label: 'Etykieta imienia i nazwiska',
        userNameSurname: 'Imię i nazwisko',
        userSurnameName: 'Nazwisko i imię',
        phone: 'Numer telefonu',
        password: 'Hasło',
        password_confirmation: 'Powtórz hasło',
        unassignedItems: 'Nieprzypisane przedmioty',
        currency: 'Waluta',
        general: 'Ogólne',
        timezone: 'Strefa czasowa',
        users: 'Użytkownicy',
        groups: 'Grupy',
        productionLine: 'Linia produkcyjna',
        part: 'Część',
        fittingParts: 'Pasujące części',
        workSchema: 'Schemat pracy',
        holiday: 'Święta',
        workSchemas: 'Schematy pracy',
        changePassword: 'Zmień hasło',
        showRest: 'Zobacz pozostałe',
        pageNotPermitted: 'Nie masz uprawnień, aby wyświetlić tę stronę',
        waitingForActivation: 'Oczekujące na aktywację',
        editGroup: 'Edytuj grupę',
        addGroup: 'Dodaj grupę',
        reportProblem: 'Zgłoś problem',
        describeOccuredIssue: 'Opisz napotkany problem',
        markAllAsRead: 'Oznacz wszystkie jako przeczytane',
        unitType: 'Typ jednostki',
        unit: 'Jednostka',
        unitPrice: 'Cena jednostkowa',
        notConfigured: 'Nieskonfigurowany',
        rowsPerPage: 'Wierszy na stronę',
        rowsOfPage: 'z',
        true: 'Prawda',
        false: 'Fałsz',
        export: 'Eksportuj',
        chooseFileFormat: 'Wybierz format pliku',
        exported: 'Wyeksportowano',
        terminals: 'Terminale',
        terminal: 'Terminal',
        selectEquipment: 'Wybierz wyposażenie',
        futureIssues: 'Przyszłe zdarzenia',
        scheduledOn: 'Zaplanowano na',
        planned: 'Planowane',
        notPlanned: 'Nieplanowane',
        showOpenIssues: 'Otwarte zgłoszenia',
        pin: 'PIN',
        assignedEquipment: 'Przypisane wyposażenie',
        terminalEquipment: 'Wysposażenie terminala',
        detach: 'Usuń',
        attach: 'Dodaj',
        dashboardConfig: 'Konfiguracja dashboardu',
        addColumn: 'Dodaj kolumnę',
        addRow: 'Dodaj wiersz',
        removeRow: 'Usuń wiersz',
        registerTerminal: 'Zarejestruj terminal',
        issueGeneratesCost: 'Przestój generuje koszt',
        selectColor: 'Wybierz kolor',
        belowMinimum: 'Poniżej minimum',
        belowOptimum: 'Poniżej optimum',
        synchronization: 'Synchronizacja',
        synchronizationExport: 'Eksport części magazynowych',
        synchronizationImport: 'Import części magazynowych',
        mapping: 'Mapowanie',
        returnTo: 'Wróć do',
        jobStatusses: 'Procesy',
        hidden: 'Ukryte',
        editEvent: 'Edytuj wydarzenie',
        threeDays: '3 dni',
        addEvent: 'Dodaj wydarzenie',
        plannedIssues: 'Zadania zaplanowane',
        currentService: 'Bieżąca obsługa',
        searchLocation: 'Szukaj lokalizacji',
        all: 'Wszystkie',
        unfinished: 'Nieukończone',
        numberOfIssues: 'Ilość zgłoszeń',
        unknown: 'Nieznany',
        partEntry: 'Część (wpis)',
        foundItems: 'Znalezione elementy',
        output: 'Wynik',
        copied: 'Skopiowano',
        link: 'Link',
        authorizationRequired: 'Wymagana autoryzacja',
        authorizationRequiredDescriptionUser:
            'Niestety nie masz wystarczających uprawnień {value}. Poproś osobę uprawnioną o zatwierdzenie operacji.',
        authorizationRequiredDescriptionTerminal:
            'Użyj swojego kodu dostępu w celu autoryzacji operacji.',
        showAll: 'Pokaż wszystkie',
        showClassicView: 'Widok klasyczny',
        externalSystems: 'Systemy zewnętrzne',
        noIssuesInCategory: 'Brak zgłoszeń w tej kategorii.',
        numberOfIssuesInThisCategoryAndSubcategories:
            'Ilość zgłoszeń w tej kategorii i jej podkategoriach.',
        numberOfIssuesInThisCategory:
            'Ilość zgłoszeń dokładnie w tej kategorii.',
        minBarcodeLength: 'Minimalna długość kodu kreskowego.',
        currentPage: 'Bieżąca strona',
        allPages: 'Wszystkie strony',
        selectFormat: 'Wybierz format',
        provided_currency: 'Wprowadzona waluta',
        provided_quantity: 'Wprowadzona ilość',
        provided_unit: 'Wprowadzona jednostka',
        provided_unit_price: 'Wprowadzona cena jednostkowa',
        unit_price: 'Cena jednostkowa',
        quantity_available: 'Dostępna ilość',
        editBarcode: 'Edytuj kod kreskowy',
        crews: 'Brygady',
        scheduleEventTypes: 'Rodzaje zdarzeń kalendarzowych',
        crew: 'Brygada',
        scheduleEvent: 'Zdarzenie kalendarzowe',
        available: 'Dostępne',
        'App\\Models\\Crew': 'Brygada',
        'App\\Models\\User': 'Użytkownik',
        'App\\Models\\Equipment': 'Wyposażenie',
        'App\\Models\\Part': 'Część',
        Crew: 'Brygada',
        User: 'Użytkownik',
        Equipment: 'Wyposażenie',
        Part: 'Część',
        scheduleEvents: 'Planowane wydarzenia',
        event: 'Wydarzenie',
        user: 'Użytkownik',
        availability: 'Dostępność',
        inheritColorFromParentIfCustomNotSet:
            'Ustaw kolor rodzica, jeśli nie jest ustawiony własny',
        pickFromAllParts: 'Wybierz z wszystkich części',
        takeTool: 'Wydaj narzędzie',
        returnTool: 'Zwróć narzędzie',
        personWhoTake: 'Osoba pobierająca',
        personWhoReturn: 'Osoba zwracająca',
        takenAt: 'Data pobrania',
        takenBy: 'Osoba pobierająca',
        toolIssuedBy: 'Osoba wydająca',
        commentTake: 'Komentarz przy pobraniu',
        commentReturn: 'Komentarz przy zwrocie',
        change: 'Zmień',
        onlyWithActiveRMIssues: 'Tylko z aktywnymi zgłoszeniami RM',
        externalSystem: 'System zewnętrzny',
        rejectIssue: 'Odrzuć zgłoszenie',
        withdrawIssueRejection: 'Wycofaj odrzucenie zgłoszenia',
        rejectionReason: 'Powód odrzucenia',
        rejected: 'Odrzucone',
        showCrewMembers: 'Pokaż członków brygady',
        crewMembers: 'Członkowie brygady',
        helpGroup: 'Służba',
        partsTakenByUser: 'Części pobrane przez pracownika',
        pickParts: 'Wydaj części',
        selectPersonWhoTakes: 'Wybierz osobę pobierającą',
        changePersonWhoTakes: 'Zmień osobę pobierającą',
        quantityToPick: 'Ilość do pobrania',
        pickLocation: 'Lokalizacja z której pobiera',
        selectPartsToPick: 'Wybierz części',
        partSelected: 'Wybrano część',
        scanCodeOr: 'Zeskanuj kod lub',
        returnPart: 'Zwróć część',
        myTakenParts: 'Części pobrane przeze mnie',
        takenFromLocation: 'Lokalizacja pobrania części',
        takenQuantity: 'Pobrana ilość',
        providedUnit: 'Wprowadzona jednostka',
        providedQuantity: 'Wprowadzona ilość',
        selectFromStorage: 'Wybierz z magazynu',
        selectFromMyPickedParts: 'Wybierz z moich części',
        exportProcessInProgressMessage:
            'Proces eksportu danych właśnie się rozpoczął, gdy zostanie zakończony zobaczysz odpowiednie powiadomienie zawierające link do pliku.',
        yourDocumentIsReady: 'Twój dokument jest gotowy',
        rotateScreen: 'Obróć ekran',
        addRule: 'Dodaj regułę',
        editRule: 'Edytuj regułę',
        summary: 'Podsumowanie',
        onlyAvailableEmployees: 'Pokaż tylko dostępnych pracowników',
        calculated_unit_price: 'Przeliczona cena jednostkowa',
        calculated_quantity: 'Przeliczona ilość',
        next: 'Dalej',
        maintenanceMode: 'Tryb konserwacji',
        applicationMayBeUnavailableForFewMinutes:
            'Aplikacja może być niedostępna przez kilka minut',
        appWillRefreshIn: 'Aplikacja zostanie przeładowana za',
        landscape: 'Poziomo',
        portrait: 'Pionowo',
        orientation: 'Orientacja',
        format: 'Format',
        service: 'Służba',
        leader: 'Brygadziści',
        defaultView: 'Domyślny widok',
        view: 'Widok',
        oneDay: '1 dzień',
        object: 'Obiekt',
        finished: 'Ukończone',
        onlyNotFinished: 'Tylko nieukończone',
        generate: 'Generuj',
        error: 'Błąd',
        cell: 'Komórka',
        resolutionSummary: 'Podsumowanie zakończenia',
        rejected_at: 'Data odrzucenia',
        rejected_by: 'Odrzucono przez',
        finishedByUser: 'Ukończone przez',
        formalConfirmByUser: 'Formalne potwierdzenie przez',
        formalConfirmAt: 'Data formalnego potwierdzenia',
        valueDeleted: '[Wartość usunięta]',
        hasNotPlannedIssue: 'Ma nieplanowane zgłoszenie',
        showInStorage: 'Pokaż w magazynie',
        changeCode: 'Zmień kod',
        staffProfiles: 'Profile pracowników',
        profile: 'Profil',
        user_bug: 'Błąd aplikacji',
        user_kaizen: 'Sugestia zmiany',
        changeSuggestions: 'Sugestie zmian',
        showOnlyCurrentlyAvailable: 'Pokaż tylko obecnie dostępnych',
        resetPassword: 'Resetuj hasło',
        forgotPassword: 'Zapomniałem hasła',
        resetPasswordMailSent:
            'Na podany adres e-mail wysłaliśmy link do ustawienia nowego hasła',
        manyEventsThisTime: 'Wiele zdarzeń w tym czasie',
        importScheduleCheckboxLabel:
            'Usuń zaplanowane zdarzenia w wybranym miesiącu dla pracowników wymienionych w pliku',
        inheritedEvent: 'Wydarzenie dziedziczone',
        inheritedModifiedEvent: 'Zmodyfikowane wydarzenie dziedziczone',
        equipmentId: 'ID wyposażenia',
        entryId: 'ID wpisu',
        partId: 'ID części',
        suggestionsEmail: 'Adres e-mail, na który będą wysyłane sugestie zmian',
        meters: 'Liczniki',
        scanCardToAuth:
            'Przyłóż kartę do czytnika lub wpisz swój kod dostępu, aby potwierdzić tożsamość.',
        scanCard: 'Zeskanuj kartę',
        cart: 'Skrzynka wymiany',
        emptyCardMessage:
            'Zacznij skanować produkty lub wybierz je z listy, aby dodać je do skrzynki wymiany.',
        terminalMode: 'Typ terminala',
        askPermittedUserToConfirmPartsExchange:
            'Poproś osobę uprawnioną o potwierdzenie wydania / zwrotu części poprzez zeskanowanie karty lub wpisanie kodu.',
        partsIssued: 'Wydano części',
        areYouSureAboutCancel: 'Czy na pewno chcesz zakończyć?',
        areYouSureAboutRemoveFromCart:
            'Czy na pewno chcesz usunąć ze skrzynki wymiany?',
        standard: 'Standardowy',
        idNumber: 'Numer identyfikacyjny',
        takeParts: 'Pobierz części',
        returnParts: 'Zwróć części',
        quantityToReturn: 'Ilość do zwrotu',
        partsPendingApproval: 'Zwrócone części oczekujące na zatwierdzenie',
        partsReturned: 'Zwrócono części',
        partsAddedToPendingApproval:
            'Części dodano na listę oczekujących na zatwierdzenie zwrotu',
        approvePartsReturn: 'Zatwierdź zwrot części',
        partReturnApproved: 'Zwrot części zatwierdzony',
        partUsage: 'Użycie części',
        awaitsReturn: 'Oczekuje na potwierdzenie zwrotu',
        entrySelection: 'Wybieranie wpisów',
        correctQuantity: 'Poprawna ilość',
        quantityCorrection: 'Korekta stanu',
        entrySelectionAsc: 'Od najmniejszej ilości',
        entrySelectionDesc: 'Od największej ilości',
        metersSettings: 'Ustawienia liczników',
        countableFields: 'Zliczane pola',
        equipmentTypes: 'Typy maszyn',
        fieldName: 'Nazwa pola',
        countableField: 'Zliczane pole',
        partsStatusTaken: 'Pobrano',
        rejectPartsReturn: 'Odrzuć zwrot części',
        areYouSureAboutRejectPartsReturn:
            'Czy na pewno chcesz odrzucić zwrot części?',
        partReturnRejected: 'Zwrot części odrzucony',
        counterFields: 'Pola liczników',
        counterName: 'Nazwa licznika',
        counterFieldName: 'Nazwa pola',
        counterId: 'ID licznika',
        counterUUID: 'UUID licznika',
        counterPickerPlaceholder: 'Wybierz licznik',
        pickFromPartsList: 'Wybierz z listy części',
        changeLocation: 'Zmień lokalizację',
        isPartStorageRoot: 'Główny magazyn części',
        isStorageRoot: 'Główny magazyn części',
        areYouSureAboutArchiveIssue:
            'Czy na pewno chcesz zarchiwizować to zgłoszenie?',
        ganttChart: 'Wykres Gantta',
        table: 'Tabela',
        fittingEquipment: 'Pasujące wyposażenie',
        notAssigned: 'Niepowiązane',
        countersValues: 'Wartości liczników',
        counters: 'Liczniki',
        machineHourlyCostNotProvided:
            'Maszyna nie ma ustawionego kosztu godzinnego',
        eventTypesMightBeDefinedHere:
            'Rodzaje zdarzeń możesz zdefiniować tutaj',
        toolsTakenByUser: 'Narzędzia pobrane przez użytkownika',
        predictedReturnDate: 'Przewidywana data zwrotu',
        estimatedTimeOfUsingToolInHours:
            'Szacowany czas używania narzędzia (w godzinach)',
        showOnlyAvailable: 'Pokaż tylko dostępne',
        toolTakeLog: 'Historia pobrań i zwrotów',
        takeDate: 'Data pobrania',
        returnDate: 'Data zwrotu',
        personWhoAcceptReturn: 'Osoba przyjmująca zwrot',
        statisticStrategy: 'Strategia dostępności',
        EquipmentPlannedStrategy: 'Według planu pracy',
        EquipmentConstantAvailabilityStrategy: 'Stała dostępność',
        actionAfterIssueFinish: 'Akcja po zakończeniu zgłoszenia',
        enabled: 'Włączone',
        categoryOfNewIssue: 'Kategoria nowego zgłoszenia',
        workNotStarted: 'Praca nie rozpoczęta',
        colorInherited: 'Kolor dziedziczony',
        abcClassification: 'Klasyfikacja ABC',
        xyzClassification: 'Klasyfikacja XYZ',
        classification: 'Klasyfikacja',
        filters: 'Filtry',
        wipeFilters: 'Wyczyść filtry',
        takePartsFromUser: 'Przyjmij części',
        selectPersonWhoReturns: 'Wybierz osobę zwracającą',
        changePersonWhoReturns: 'Zmień osobę zwracającą',
        returnLocation: 'Lokalizacja zwrotu',
        returnQuantity: 'Zwracana ilość',
        globalSettings: 'Ustawienia globalne',
        delimiter: 'Separator',
        fieldRules: 'Reguły pola',
        fieldValue: 'Wartość pola',
        user_email_regex: 'Reguła e-mail',
        barcodeLength: 'Długość kodu kreskowego.',
        partLine: 'Linia części',
        partFamily: 'Rodzina części',
        partBatch: 'Partia części (batch)',
        testValueValid: 'Wartość testowa spełnia regułę',
        testValueNotValid: 'Wartość testowa nie spełnia reguły',
        canBePicked: 'Wybieralna',
        create_issue_criticality: 'Tworzenie zgłoszenia - krytyczność',
        issue_criticality: 'Zgłoszenia - krytyczność',
        issue_help_webapp: 'Zgłoszenia - potrzebne wsparcie (Aplikacja)',
        issue_help_terminal: 'Zgłoszenia - potrzebne wsparcie (Terminal)',
        issue_kind: 'Rodzaj zgłoszenia',
        HIDE: 'Ukryj',
        SHOW: 'Pokaż',
        REQUIRE: 'Wymagaj',
        propagateValues: 'Propaguj wartości',
        archived: 'Zarchiwizowane',
        singleEvent: 'Pojedynczy wpis',
        seriesOfEvents: 'Seria wpisów',
        omitWeekends: 'Omiń weekendy',
        allEntriesSaved: 'Wszystkie wpisy zostały dodane',
        parentCategory: 'Kategoria nadrzędna',
        first_day_of_week: 'Pierwszy dzień tygodnia',
        assignWorker: 'Przypisz pracownika',
        addNewMachine: 'Dodaj nową maszynę',
        addNewTool: 'Dodaj nowe narzędzie',
        parentLocation: 'Lokalizacja nadrzędna',
        equipmentStates: 'Stany wyposażenia',
        equipmentState: 'Stan wyposażenia',
        fontColor: 'Kolor czcionki',
        downtime: 'Przestój',
        setState: 'Ustaw stan',
        from: 'Od',
        to: 'Do',
        inProgress: 'W trakcie',
        noEntries: 'Brak wpisów',
        products: 'Produkty',
        product: 'Produkt',
        setCurrentProduct: 'Ustaw obecnie produkowany produkt',
        commentable: 'Możliwość komentarza',
        allows_state_update: 'Wymagana zmiana stanu podczas komentarza',
        undescribed: 'Nieopisany',
        state: 'Stan',
        productionMonitor: 'Monitor produkcji',
        undescribedStates: 'Stany nieopisane',
        toolsPicker: 'Pobór / zwrot narzędzi',
        toolsGroups: 'Grupy narzędzi',
        of: 'z',
        image: 'Zdjęcie',
        selectTools: 'Wybierz narzędzia',
        takeTools: 'Pobierz narzędzia',
        returnTools: 'Zwróć narzędzia',
        askPermittedUserToConfirmToolsExchange:
            'Poproś osobę uprawnioną o potwierdzenie wydania / zwrotu narzędzi poprzez zeskanowanie karty lub wpisanie kodu.',
        toolsPendingApproval: 'Zwrócone narzędzia oczekujące na zatwierdzenie',
        production_monitor_visible_columns:
            'Monitor produkcji - widoczne kolumny',
        details: 'Szczegóły',
        otherData: 'Inne dane',
        showAllTools: 'Pokaż wszystkie narzędzia',
        allTools: 'Wszystkie narzędzia',
        approveToolReturn: 'Zaakceptuj zwrot narzędzia',
        rejectToolReturn: 'Odrzuć zwrot narzędzia',
        areYouSureAboutRejectToolReturn:
            'Czy na pewno chcesz odrzucić zwrot narzędzia?',
        areYouSureAboutAcceptToolReturn:
            'Czy na pewno chcesz potwierdzić zwrot narzędzia?',
        toolReturnApproved: 'Zatwierdzono zwrot narzędzia',
        toolReturnRejected: 'Odrzucono zwrot narzędzia',
        toReturn: 'Do zwrotu',
        toolsCart: 'Skrzynka wymiany - narzędzia',
        toolsIssued: 'Pobrano narzędzia',
        toolsAddedToPendingApproval:
            'Narzędzia dodano na listę oczekujących na zatwierdzenie zwrotu',
        toolsReturned: 'Zwrócono narzędzia',
        mainShift: 'Zmiana główna',
        scanCode: 'Zeskanuj kod',
        codeRecognized: 'Rozpoznano kod',
        moveAllEntriesFromCurrentLocation:
            'Przenieś wszystkie wpisy z tej lokalizacji',
        newAwaitingValue: 'Nowa wartość oczekująca na akceptację',
        newValuesArePendingConfirmation: 'Zmiany oczekują na akceptację',
        changeRequests: 'Prośby o zmianę',
        currentValues: 'Obecne wartości',
        requestedValues: 'Wartości do zmiany',
        removeRequestIsWaitingForApprove: 'Usunięcie oczekuje na akceptację',
        imageRemoveRequestLabel: 'Usunięcie zdjęcia',
        areYouSureAboutCancelChangeRequest:
            'Czy na pewno chcesz anulować prośbę o zmianę?',
        document: 'Dokument',
        rename: 'Zmień nazwę',
        openInEditor: 'Otwórz w edytorze',
        unsavedChangesMayBeLost: 'Niezapisane zmiany mogą zostać utracone',
        location_name_regex: 'Reguła nazwy lokalizacji',
        employeesWorkingCount:
            'Ilość pracowników pracujących nad tym zgłoszeniem',
        always: 'Zawsze',
        indexes: 'Indeksy',
        indexesEntriesTypes: 'Typy wpisów',
        indexEntry: 'Wpis indeksu',
        index: 'Indeks',
        pickIndex: 'Wybierz indeks',
        report: 'Raport',
        reportGenerationInProgress: 'Trwa generowanie raportu',
        production_monitor_equipment_state_change:
            'Zmiana stanu maszyny z poziomu monitora produkcji',
        part_entries_auto_barcode_generation:
            'Automatyczne generowanie kodów kreskowych dla wpisów części',
        new_issue_equipment_kind: 'Typ wyposażenia w nowym zgłoszeniu',
        manageVisibleColumns: 'Dostosuj widoczność kolumn',
        columnName: 'Nazwa kolumny',
        visible: 'Widoczne',
        partStorageRootWarningMessage:
            'Ta lokalizacja zostanie ustawiona jako główna lokalizacja magazynu części, magazyn oraz okno wyboru lokalizacji pozwoli jedynie na wybieranie wpisów znajdujących się w tej lokalizacji',
        entriesLocation: 'Lokalizacja wpisów',
        cloneIssue: 'Klonuj',
        machinesMap: 'Mapa maszyn',
        doYouWantToAddNewMarker:
            'Czy chcesz dodać nowy znacznik w tym miejscu?',
        areYouSureAboutRemoveMarker: 'Czy na pewno chcesz usunąć ten znacznik?',
        plants: 'Zakłady fabryczne',
        plant: 'Zakład',
        buildings: 'Budynki',
        building: 'Budynek',
        floors: 'Piętra',
        floor: 'Piętro',
        map: 'Mapa',
        areYouSureAboutMoveMarker:
            'Czy na pewno chcesz przesunąć ten znacznik?',
        marker: 'Znacznik',
        addNewMarkerTooltipMessage:
            'Aby dodać nowy znacznik kliknij na mapę prawym przyciskiem myszki.',
        takenTools: 'Pobrane narzędzia',
        askPermittedUserToConfirmToolExchange:
            'Poproś osobę uprawnioną o potwierdzenie wydania / zwrotu narzędzia poprzez zeskanowanie karty lub wpisanie kodu.',
        warnDays: 'Alert przed wygaśnięciem (dni)',
        licenseType: 'Typ licencji',
        licenseGroup: 'Grupa licencji',
        toolsCartTerminalRequireApproveOnToolReturn:
            'Wymagaj potwierdzenia / odrzucenia przy zwrocie pobranych narzędzi',
        attachments: 'Załączniki',
        attachment: 'Załącznik',
        searchInCurrentLocation: 'Szukaj w obecnej lokalizacji',
        icon: 'Ikona',
        nfc: 'NFC',
        rfid: 'RFID',
        other: 'Inny',
        tags: 'Karty / Tagi',
        tag: 'Karta / Tag',
        userPinCode: 'Pin użytkownika karty',
        pin_code_field_type: 'Typ kodu pin',
        alphanumeric: 'Alfanumeryczne',
        numeric: 'Numeryczne',
        showCodeOwnerNameDuringParing:
            'Pokaż nazwę właściciela kodu podczas parowania z kartą / tagiem',
        showUsernameInCart: 'Pokaż nazwę użytkownika w koszyku',
        flag: 'Flaga',
        flags: 'Flagi',
        manageFlags: 'Zarządzaj flagami',
        skills: 'Umiejętności',
        skill: 'Umiejętność',
        skillRank: 'Ocena',
        selectToolsByType: 'Wybierz narzędzia po typie',
        openToolsPickerOnCartInit:
            'Automatycznie otwieraj okno wyboru narzędzi po przejściu do koszyka.',
        toolsTypes: 'Typy narzędzi',
        workOrderTemplates: 'Szablony zleceń pracy',
        workOrderTemplate: 'Szablon zlecenia pracy',
        workOrders: 'Zlecenia pracy',
        workOrder: 'Zlecenie pracy',
        employee: 'Pracownik',
        workOrderCreatedBy: 'Zlecone przez',
        print: 'Drukuj',
        issueCreated: 'Utworzono zgłoszenie',
        newIssue: 'Nowe zgłoszenie',
        sampleButtonPlaceholder: 'Przykładowy przycisk',
        preferences: 'Preferencje',
        buttonsSize: 'Wielkość przycisków',
        defaultValue: 'Domyślna wartość',
        warning: 'Ostrzeżenie',
        allowedIssuesCategories: 'Dozwolone kategorie zgłoszeń',
        hideAbilityToAssignEmployeesToIssue:
            'Ukryj możliwość przypisywania pracowników do zgłoszenia',
        issuesWithRelatedCategories: 'Uwzględnij kategorie podrzędne',
        issuesLimit: 'Limit zgłoszeń',
        issuesLimits: 'Zgłoszenia - limity',
        closeLocker: 'Zamknij szafkę',
        closeLockerMessage: 'Aby kontynuować zamknij szafkę',
        closedTooFast: 'Zamknąłeś za szybko?',
        doYouWantToReopenLocker: 'Czy chcesz ponownie otworzyć szafkę?',
        reopen: 'Otwórz ponownie',
        quit: 'Zakończ',
        hiddenFields: 'Ukryte pola',
        defaultValues: 'Domyślne wartości',
        paddingBottom: 'Puste miejsce z dołu',
        allVisibleFieldsRequired:
            'Wymagaj uzupełnienia wszystkich widocznych pól',
        emailConfirmation: 'Potwierdzenie adresu email',
        user_active_after_email_confirm:
            'Konto użytkownika automatycznie aktywowane po potwierdzeniu adresu e-mail',
        phone_change_requires_confirmation_code:
            'Zmiana numeru telefonu wymaga potwierdzenia kodem',
        toolsLocation: 'Lokalizacja narzędzi',
        emails: 'Adresy email',
        phoneNumbers: 'Numery telefonów',
        manageFilters: 'Zarządzaj filtrami',
        erase: 'Wymaż',
        can_pick_undescribed_equipment_state:
            'Możliwość wybrania stanu nieopisanego',
        helpdesk: 'Pomoc techniczna',
        measureTypes: 'Typy pomiarów',
        measureType: 'Typ pomiaru',
        measurable: 'Wskaźnik mierzalny',
        measurables: 'Wskaźniki mierzalne',
        measurements: 'Pomiary',
        measurement: 'Pomiar',
        measuredAt: 'Data pomiaru',
        employeeNumber: 'Numer pracownika',
        lastLocation: 'Ostatnia lokalizacja',
        lastMeasurements: 'Ostatnie pomiary',
        chart: 'Wykres',
        readonly: 'Tylko do odczytu',
        equipment: 'Wyposażenie',
        conditions: 'Warunki',
        permission: 'Uprawnienie',
        formula: 'Formuła',
        notification: 'Powiadomienie',
        transition: 'Przejście',
        fillValuesToChangeState: 'Uzupełnij wartości, aby zmienić status',
        loginTo: 'Zaloguj się do',
        appName: 'Signalo CMMS',
        manageState: 'Zarządzaj stanem',
        webMessage: 'Wiadomość web',
        terminalId: 'ID terminala',
        operatorId: 'ID operatora',
        newConversation: 'Nowy wątek',
        application: 'Aplikacja',
        phones: 'Numery telefonów',
        message: 'Wiadomość',
        channels: 'Kanały',
        url: 'URL',
        kind: 'Rodzaj',
        forkfleetConfigId: 'Konfiguracja Forkfleet',
        create: 'Utwórz',
        terminate: 'Zakończ',
        recreateIssue: 'Utwórz ponownie zgłoszenie',
        top10: 'Top 10',
        period: 'Okres',
        issuesCount: 'Liczba zgłoszeń',
        timeSum: 'Łączny czas',
        stacked: 'Skumulowany wykres słupkowy',
        license: 'Uprawnienie',
        ordinal: 'Wartość porządkowa',
        parameterName: 'Nazwa parametru',
        backgroundColor: 'Kolor tła',
        columns: 'Liczba kolumn',
        colspan: 'Szerokość (kolumny)',
        fill: 'Uzupełnij',
        duplicate: 'Duplikuj',
        loginAsThisUser: 'Zaloguj się jako ten użytkownik',
        partLot: 'Seria',
        addNewDictionary: 'Dodaj nowy słownik',
        label: 'Etykieta',
        evaluated: 'Wyliczany',
        isTree: 'Drzewo',
        pickedItem: 'Wybrany element',
        pick: 'Wybierz',
        fillControl: 'Uzupełnij kontrolę',
        minBrowserVersion: 'Minimalna wymagana wersja przeglądarki',
        currentVersion: 'Obecna wersja',
        equipment_planned_completed_percent_target:
            'Procentowy cel realizacji przeglądów planowanych',
        autoTranslate: 'Automatyczne tłumaczenie',
        auto_translation: 'Automatyczne tłumaczenia',
        awaitingAutoTranslation: 'Oczekiwanie na automatyczne tłumaczenie',
        signaturePinTagConfirmationText1: 'Podpisz się @:common.PIN_CODE_LABEL',
        signaturePinTagConfirmationText2: 'lub zeskanuj swoją kartę.',
        signedWithPinCode: 'Podpisano @:common.PIN_CODE_LABEL',
        signedWithTAG: 'Podpisano Kartą / Tagiem ',
        alternative_user_for_imported_issue:
            'Domyślny użytkownik dla importowanych zgłoszeń.',
        hide_parameter_types: 'Nie wyświetlaj typu parametru',
        trusted_device_code_login_users_limit:
            'Szybkie logowanie - liczba wyświetlanych użytkowników',
        display_fields_issue_created_at:
            'Wyświetlanie pól - Utworzenie zgłoszenia',
        docs_sidebar_hidden_by_default: 'Ukryj panel boczny w dokumentach',
        control: 'Kontrola',
        issue: 'Zgłoszenie',
        compatibility: 'Kompatybilność',
        replacement: 'Zamiennik',
        backCompatibility: 'Kompatybilność w obie strony',
    },
    placeholders: {
        part: 'Wybierz część...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Numer telefonu...',
        password: 'Hasło...',
        password_confirmation: 'Powtórz hasło...',
        email: 'E-mail...',
    },
    auth: {
        notYourAccountQuestion: 'To nie ty?',
    },
    signup: {
        registered: 'Zarejestrowano!',
        emailConfirmed: 'Email został potwierdzony.',
        registered_info: 'Poproś przełożonego o aktywację konta',
        confirmEmailAddress:
            'Twoje konto zostało utworzone, kliknij w link w wiadomości email, aby potwierdzić adres.',
        tokenNotFoundError:
            'Email został już potwierdzony lub link jest niepoprawny.',
    },
    paramTypes: {
        text: 'Tekst',
        note: 'Notatka',
        integer: 'Liczba całkowita',
        decimal: 'Liczba',
        date: 'Data',
        time: 'Godzina',
        datetime: 'Data i godzina',
        color: 'Kolor',
        icon: 'Ikona',
        boolean: 'Nie / Tak',
        signature: 'Podpis',
    },
    tableHeaders: {
        id: 'ID',
        name: 'Nazwa',
        path: 'Ścieżka',
        category: 'Kategoria',
        equipment: 'Wyposażenie',
        criticality: 'Krytyczność',
        status: 'Status',
        created: 'Utworzone',
        createdBy: 'Utworzone przez',
        fp: 'FP',
        type: 'Typ',
        designation: 'Oznaczenie',
        symbol: 'Symbol',
        serialNumber: 'Nr fabryczny',
        registryNumber: 'Nr ewidencyjny',
        udtNumber: 'Nr UDT',
        manufacturedYear: 'Rok produkcji',
        actions: 'Akcje',
        title: 'Tytuł',
        data: 'Data',
        archived: 'Zarchiwizowane',
        manufacturerSymbol: 'Symbol producenta',
        min: 'Min',
        opt: 'Opt',
        quantity: 'Stan (ilość)',
        priority: 'Priorytet',
        price: 'Cena',
        kind: 'Rodzaj',
        description: 'Opis',
        default: 'Domyślny',
        warning: 'Ostrzeżenie',
        problem: 'Problem',
        fixing: 'Naprawa',
        changeOrder: 'Zmień kolejność',
        required: 'Wymagane',
        icon: 'Ikona',
        color: 'Kolor',
        subCategories: 'Kategorie podrzędne',
        barCode: 'Kod kreskowy',
        subLocations: 'Lokalizacje podrzędne',
        categories: 'Kategorie',
        image: 'Zdjęcie',
        nameSurname: '@:common.USER_NAME_LABEL',
        email: 'Email',
        phone: 'Numer telefonu',
        function: 'Funkcja',
        department: 'Wydział',
        accountStatus: 'Status konta',
        shift: 'Zmiana',
        licenseNumber: 'Number uprawnień',
        issuedDate: 'Data wydania',
        expiresDate: 'Data ważności',
        entries: 'Wpisy',
        entryNumber: 'Numer wpisu',
        buyPrice: 'Cena zakupu',
        currentLocationQuantity: 'Ilość w bieżącej lokalizacji',
        group: 'Grupa',
        string: 'Tekst',
        integer: 'Liczba',
        toolsGroup: 'Grupa narzędzi',
        manufacturer: 'Producent',
        shortName: 'Nazwa skrócona',
        locationName: 'Nazwa lokalizacji',
        subLocationsQuantity: 'Lokalizacje podrzędne',
        isWorkingOnIssue: 'Ma podjęte zgłoszenie',
        openIssues: 'Otwarte zgłoszenia',
        notificationDate: 'Data powiadomienia',
        titleAndDescription: 'Tytuł i opis',
        read: 'Odczytane',
        created_at: 'Przypisanie',
        received_at: 'Odczytanie',
        started_at: 'Podjęcie',
        arrived_at: 'Przybycie',
        finished_at: 'Zakończenie',
        country: 'Kraj',
        city: 'Miasto',
        progress: 'Progres',
    },
    searchConfig: {
        id: 'Id',
        name: 'Nazwa...',
        shortName: 'Nazwa skrócona...',
        country: 'Kraj...',
        email: 'Email...',
        group: 'Grupa...',
        planned: 'Planowane',
        category: 'Kategoria...',
        object: 'Obiekt...',
        criticality: 'Krytyczność',
        fp: 'FP',
        type: 'Typ...',
        designation: 'Oznaczenie...',
        symbol: 'Symbol...',
        serialNumber: 'Numer fabryczny...',
        registryNumber: 'Numer ewidencyjny...',
        udtNumber: 'Numer UDT...',
        manufacturedYear: 'Rok produkcji...',
        manufacturerSymbol: 'Symbol producenta...',
        priority: 'Priorytet...',
        quantity: 'Ilość...',
        buyPrice: 'Cena zakupu...',
        kind: 'Rodzaj...',
        toolsGroup: 'Grupa narzędzi...',
        function: 'Funkcja...',
        department: 'Wydział...',
        status: 'Status...',
        nameSurname: '@:common.USER_NAME_LABEL',
        phone: 'Telefon...',
        barCode: 'Kod kreskowy',
        color: 'Kolor...',
        icon: 'Ikona...',
        machine: 'Maszyna...',
        tool: 'Narzędzie...',
        urgentAndOutdated: 'Pilne i przeterminowane',
        urgent: 'Pilne',
        expired: 'Przeterminowane',
        manufacturer: 'Producent',
    },
    errors: {
        error: 'Wystąpił błąd',
        wrongEmail: 'Niewłaściwy adres email',
        wrongPasswordLength: 'Hasło musi zawierać co najmniej 8 znaków.',
        wrongCodeLength: 'Kod musi zawierać co najmniej 5 znaków.',
        passwordsNotMatch: 'Hasła nie są takie same',
        codesNotMatch: 'Kody nie są takie same',
        codeAlreadyInUse: 'Ten kod jest już w użyciu',
        expiresDateLowerThanIssued:
            'Data ważności nie może być mniejsza niż data wydania',
        cannotMoveToTheSameLocation:
            'Nie można przenieść do tej samej lokalizacji.',
        locationRequired: 'Lokalizacja jest wymagana.',
        putQuantity: 'Podaj ilość którą chcesz oddzielić.',
        valueGreaterThanQuantity: 'Wartość przekracza całkowitą ilość.',
        wholeCannotBeDistinguished: 'Nie można wydzielić całości.',
        yearMustBeGreaterThan: 'Rok musi być większy niż ',
        passwordConfirmationNotMatch: 'Hasła nie są takie same',
        mustBeInteger: 'Wartość musi być liczbą całkowitą',
        valueTooLong: 'Za długa wartość',
        wrongPhoneNumber: 'Zły numer telefonu',
        phoneNumberAlreadyTaken: 'Ten numer telefonu jest już używany',
        emailAlreadyTaken: 'Ten adres email jest już używany',
        notFound: 'Nie znaleziono',
        sessionExpired: 'Sesja wygasła',
        tenantNotFound:
            'Wskazana konfiguracja nie istnieje. Popraw adres strony i spróbuj ponownie.',
        selectEquipmentTypeToConfigureParameters:
            'Wybierz typ wyposażenia, aby skonfigurować parametry',
        noParametersToConfigure:
            'Wybrany typ wyposażenia nie ma parametrów do skonfigurowania',
        terminalAlreadyRegistered: 'Ten terminal został już zarejestrowany.',
        invalidPin: 'Niepoprawny PIN',
        eventCollision:
            'Czas wydarzenia które chcesz dodać nakłada się na czas trwania innego wydarzenia.',
        mustStartWithSlash: 'Musi zaczynać się od /',
        mustBeBetween: 'Wartość musi się mieścić pomiędzy:',
        minLength: 'Minimalna długość: ',
        maxLength: 'Maksymalna długość: ',
        invalidInputForCodeType: 'Niepoprawna wartość dla wybranego typu kodu',
        invalidCodeOrNoPermission:
            'Kod jest nieprawidłowy lub nie masz wystarczających uprawnień do wykonania tej akcji.',
        endDateLowerThanStart:
            'Data końcowa nie może być wcześniejsza niż data początkowa',
        iconAlreadyTaken: 'Ikona jest już w użyciu',
        notEnoughQuantityInStorage: 'Niewystarczająca ilość w magazynie.',
        valueTooLow: 'Zbyt niska wartość',
        valueTooHigh: 'Zbyt duża wartość',
        maxAvailableQuantity: 'Maksymalna ilość',
        someFilesRejectedDueToSize:
            'Niektóre pliki zostały odrzucone ze względu na rozmiar. Maksymalny rozmiar pojedynczego pliku:',
        cameraDeviceNotFound: 'Nie wykryto kamery',
        cameraPermissionDenied:
            'Dostęp do kamery urządzenia został zablokowany w ustawieniach strony, zresetuj ustawienia witryny i zezwól na używanie kamery.',
        uploadError: 'Błąd przesyłania pliku',
        finishedSuccessfully: 'Zakończono pomyślnie',
        passwordResetLinkExpired: 'Ważność linku do zmiany hasła wygasła',
        noInternetConnection: 'Brak połączenia z internetem',
        partsAvailabilityError:
            'Dostępność niektórych z wybranych elementów uległa zmianie. Edytuj zawartość swojej skrzynki wymiany i spróbuj ponownie.',
        minimum: 'Minimalna wartość',
        mustBeGreaterThan: 'Wartość musi być większa niż',
        noEventTypesDefined: 'Nie zdefiniowano typów wydarzeń',
        regexPatternDelimiterError:
            "Separator musi być poprzedzony znakiem '\\' np: \\/",
        emailNotMatchPatternDefiniedInTenant:
            'Adres email nie pasuje do wzorca zdefiniowanego w konfiguracji',
        partMustHaveEntriesToCorrectQuantity:
            'Część musi mieć wpisy, aby skorygować ilość.',
        fileTooBigToOpenWillBeDownloaded:
            'Plik jest duży, aby go wyświetlić, plik zostanie pobrany na twoje urządzenie.',
        entriesNotSavedDueToCollision:
            'Wpisy nie zostały dodane. W wybranym czasie istnieją już wydarzenia.',
        someEntriesWereRejected:
            'Niektóre wpisy nie zostały dodane, ponieważ kolidują z innymi wydarzeniami.',
        toolAlreadyInCart: 'To narzędzie już znajduje się w koszyku.',
        toolAlreadyTaken: 'To narzędzie zostało już wydane',
        toolIsNotTaken: 'To narzędzie nie zostało wydane',
        documentNotEditable: 'Ten dokument nie ma możliwości edycji',
        notPermissionsToEditDocument:
            'Nie masz uprawnień aby edytować ten dokument',
        cannotLoadDocumentNoPath:
            'Nie można załadować dokumenu - niepoprawny adres',
        locationNameNotMatchPatternDefiniedInTenant:
            'Nazwa nie spełnia reguły zdefiniowanej w ustawieniach',
        noFloorLayoutProvided: 'Piętro nie ma zdefiniowanej mapy',
        maximum: 'Maksymalna wartość',
        allLanguagesRequired: 'Uzupełnij wartość we wszystkich językach',
        noItemsAvailable: 'Brak dostępnych przedmiotów',
        noFlagsConfigured: 'Nie zdefiniowano flag',
        noSkillsDefined: 'Nie zdefiniowano umiejętności',
        someoneIsWorkingOnIssue:
            'Nie wszyscy pracownicy zakończyli pracę nad tym zgłoszeniem. Czy na pewno chcesz je zakończyć?',
        fillAllRequiredParameters: 'Uzupełnij wszystkie wymagane parametry.',
        issueLimitError: 'Osiągnięto limit zgłoszeń w wybranej kategorii dla: ',
        issueLimitError2: 'i funkcji: ',
        duplicateError: 'Podana wartość już istnieje',
        versionErrorMessage:
            'Twoje ostatnie zmiany nie zostały zapisane, ponieważ ktoś inny dokonał zmian w tym samym czasie. Odśwież stronę i spróbuj ponownie.',
        firstLoginTrustedDeviceError:
            'Pierwsze logowanie na nowym urządzeniu wymaga podania adresu email i hasła.',
        tagNotFound: 'Nie rozpoznano karty / tagu',
        noChecklistsAssignedToControl:
            'Wybrane zlecenie nie posiada przypisanej listy kontrolnej',
        lockerNotConnected: 'Zamek jest niepodłączony',
        lockerNotAvailable: 'Zamek jest niedostępny',
        noChecklistItemsError: 'Lista kontrolna jest nieskonfigurowana',
    },
    navDrawer: {
        dashboard: 'Dashboard',
        issues: 'Zgłoszenia',
        timetable: 'Harmonogram',
        machines: 'Maszyny',
        tools: 'Narzędzia',
        parts: 'Części i materiały',
        storage: 'Magazyn',
        staff: 'Personel',
        configuration: 'Konfiguracja',
        notes: 'Notatki',
        notifications: 'Powiadomienia',
        profile: 'Profil',
        supervision: 'Dozór',
    },
    barcodeScanner: {
        barCode: 'Kod kreskowy',
        id: 'ID',
    },
    categoryPicker: {
        categoryPlaceholder: 'Kategoria...',
        selectCategory: 'Wybierz kategorię',
        noSubcategories: 'Brak kategorii podrzędnych',
    },
    companies: {
        addCompany: 'Dodaj firmę',
        editCompany: 'Edytuj firmę',
        fullName: 'Pełna nazwa',
        shortName: 'Nazwa skrócona',
        group: 'Grupa',
        country: 'Kraj',
        city: 'Miasto',
        street: 'Ulica',
        postCode: 'Kod pocztowy',
        phone: 'Telefon',
        email: 'Email',
        website: 'Strona internetowa',
        NIP: 'NIP',
        REGON: 'REGON',
        active: 'Aktywna',
        nameRequired: 'Nazwa jest wymagana',
        shortNameRequired: 'Nazwa jest wymagana',
    },
    issues: {
        tookAt: 'Podjęte',
        changeHistory: 'Historia zmian',
        load: 'Załaduj',
        date: 'Data',
        createdBy: 'Wprowadził',
        action: 'Akcja',
        data: 'Dane',
        created: 'Utworzono',
        updated: 'Zaktualizowano',
        deleted: 'Usunięto',
        restored: 'Przywrócono',
        issues: 'Zgłoszenia',
        issue: 'Zgłoszenie',
        by: 'przez',
        name: 'Nazwa',
        applicantsDescription: 'Opis zgłaszającego',
        accidentDescription: 'Opis awarii',
        jobDescription: 'Opis zlecenia',
        jobSummary: 'Podsumowanie zlecenia',
        category: 'Kategoria',
        status: 'Status',
        noFlow: '[Brak przepływu]',
        equipment: 'Wyposażenie',
        criticality: 'Krytyczność',
        hour: 'Godzina',
        formalConfirmation: 'Formalne potwierdzenie',
        formalConfirmationShortcut: 'FP',
        formalConfirmationRequired: 'FP wymagane',
        parameter: 'Parametr',
        value: 'Wartość',
        addIssue: 'Dodaj zgłoszenie',
        expectedCompletionDate: 'Przewidywany termin realizacji',
        issueDescription: 'Opis zdarzenia',
        partsUsage: 'Rozchód części',
        assignedEmployees: 'Przypisani pracownicy',
        requiredHelp: 'Potrzebne wsparcie',
        returnParts: 'Zwróć część',
        confirmUnassignEmployeeWhoTakenIssue:
            'Ten użytkownik podjął wybrane zgłoszenie. Czy napewno chcesz go usunąć?',
        responsibleUser: 'Osoba odpowiedzialna za zgłoszenie',
        responsibleRules: 'Odpowiedzialni - reguły',
    },
    machines: {
        machines: 'Maszyny',
        xIssuesNotPlanned: ' (nie planowanych)',
        noIssues: 'Brak zgłoszeń',
    },
    maintenance: {
        maintenance: 'Harmonogram',
    },
    notes: {
        notes: 'Notatki',
        note: 'Notatka',
        title: 'Tytuł',
        archived: 'Zarchiwizowane',
    },
    parts: {
        parts: 'Części i materiały',
        warehouseOutgoings: 'Rozchód magazynowy',
        fittingEquipmentTypes: 'Pasujące typy wyposażenia',
        goToEquipmentType: 'Typ wyposażenia',
        selectPart: 'Wybierz część',
        usageReason: 'Powód',
        usageOtherReason: 'Inny',
        replacements: 'Zamienniki',
        partEntry: 'Wpis części',
        goToPart: 'Idź do części',
        fittingMachines: 'Pasujące maszyny',
    },
    costCenter: {
        costCenter: 'Miejsce powstania kosztów',
    },
    equipmentTypes: {
        equipment: 'Wyposażenie',
        newEquipmentType: 'Nowy typ wyposażenia',
        fittingParts: 'Pasujące części i materiały',
        goToParts: 'Przejdź do części',
    },
    machinesAndToolsDefinitions: {
        machinesAndToolsDefinitions: 'Definicje typów maszyn i narzędzi',
    },
    flows: {
        flow: 'Przepływ',
        states: 'Stany',
        transitions: 'Przejścia',
        state: 'Stan',
        default: 'Domyślny',
        warning: 'Ostrzeżenie',
        problem: 'Problem',
        fixing: 'Naprawa',
        finished: 'Ukończone',
    },
    parameters: {
        categoryParameter: 'Parametr kategorii',
        equipmentTypeParameter: 'Parametr typu wysposażenia',
    },
    staff: {
        staff: 'Personel',
        editUserAccess: 'Edytuj dostęp użytkownika',
        permissionsUpdated: 'Zaktualizowano uprawnienia',
        passwordUpdated: 'Zaktualizowano hasło',
        codeUpdated: 'Zaktualizowano kod',
        changePasswordAndCode: 'Zmień hasło i kod',
        goToLicenses: 'Idź do uprawnień',
        editAccess: 'Edytuj dostęp',
        editUser: 'Edytuj użytkownika',
        addUser: 'Dodaj nowego użytkownika',
        nameAndLastname: '@:common.USER_NAME_LABEL',
        accountStatus: 'Status konta',
        phoneNumber: 'Numer telefonu',
        department: 'Wydział',
        passwordChange: 'Zmiana hasła',
        codeChange: 'Zmiana kodu',
        newPassword: 'Nowe hasło',
        confirmNewPassword: 'Potwierdź nowe hasło',
        changePassword: 'Zmień hasło',
        newCode: 'Nowy kod',
        confirmNewCode: 'Potwierdź nowy kod',
        changeCode: 'Zmień kod',
        addEntry: 'Dodaj wpis',
        editEntry: 'Edytuj wpis',
        editLicense: 'Edytuj uprawnienie',
        addLicense: 'Dodaj uprawnienie',
        licenseNumber: 'Numer uprawnień',
        prefferedLocale: 'Preferowany język',
        oldPassword: 'Stare hasło',
        newPasswordConfirmation: 'Potwierdź nowe hasło',
        reading: 'Wyświetlanie',
        creating: 'Wprowadzanie',
        updating: 'Modyfikacja',
        deleting: 'Usuwanie',
        importScheduleFile: 'Importuj harmonogram z pliku',
        importSchedule: {
            errors: {
                user_not_found: 'Nie znaleziono użytkownika [{user}]',
                user_found_many: 'Znaleziono {count} użytkowników [{user}]',
                event_collision: 'Kolizja wydarzeń',
                hour_cell_parse: 'Błąd parsowania komórki',
            },
        },
        oldCode: 'Stary kod',
        newCodeConfirmation: 'Potwierdzenie nowego kodu',
        setAccessBasedOnProfile: 'Nadaj dostęp na podstawie profilu',
        selectAccessMergeType: 'Wybierz sposób łączenia uprawnień',
        noAccessesInProfileMessage:
            'Wybrany profil nie posiada żadnych uprawnień. Czy chcesz nadpisać mimo to?',
    },
    breadCrumb: {
        configuration: 'Konfiguracja',
        locations: 'Lokalizacje',
        home: 'Dashboard',
        machines: 'Maszyny',
        tools: 'Narzędzia',
        issues: 'Zgłoszenia',
        notes: 'Notatki',
        maintenance: 'Harmonogram',
        parts: 'Części i materiały',
        warehouse: 'Magazyn',
        dictionary: 'Słownik',
        categories: 'Kategorie',
        parameters: 'Parametry',
        costCenter: 'Miejsce powstania kosztów',
        flows: 'Przepływy',
        states: 'Stany',
        transitions: 'Przejścia',
        shiftSchemas: 'Schematy zmian',
        shifts: 'Zmiany',
        definitionsOfMachinesAndToolsTypes: 'Definicje typów maszyn i narzędzi',
        add: 'Dodawanie',
        edit: 'Edycja',
        staff: 'Personel',
        licenses: 'Uprawnienia',
        entries: 'Wpisy',
        companiesDatabase: 'Baza firm',
        companyManagement: 'Zarządzanie firmą',
        notifications: 'Powiadomienia',
        notificationsManagement: 'Zarządzanie powiadomieniami',
        myProfile: 'Mój profil',
    },
    attributeTypes: {
        text: 'Tekst',
        note: 'Notatka',
        integer: 'Liczba całkowita',
        decimal: 'Liczba',
        date: 'Data',
        time: 'Godzina',
        dateTime: 'Data i godzina',
        color: 'Kolor',
        icon: 'Ikona',
        boolean: 'Tak/Nie',
    },
    costCalculator: {
        costCalculator: 'Kalkulator kosztów',
        waitTime: 'Czas oczekiwania',
        serviceTime: 'Czas obsługi',
        suspendTime: 'Czas zawieszenia',
        totalTime: 'Czas całkowity',
        estimatedCost: 'Szacowany koszt',
        calculate: 'Przelicz',
        withoutParts: 'Bez części',
        timeOfReportingIssue: 'Zgłoszenie zdarzenia',
        timeOfServiceStart: 'Rozpoczęcie obsługi',
        timeOfReportingEnd: 'Zakończenie obsługi',
        days: 'Dni',
        hours: 'Godzin',
        minutes: 'Minut',
        enterNewTime: 'Podaj nowy czas',
        fromIssueReportToServiceStart: 'Czas od zgłoszenia do rozpoczęcia',
        fromServiceStartToServiceEnd:
            'Czas od rozpoczęcia obsługi do zakończenia obsługi',
        workTime: 'Czas pracy',
        includeAwaitingTime: 'Wlicz czas oczekiwania',
    },
    dashboard: {
        components: {
            myIssues: {
                title: 'Moje zgłoszenia',
                assignedToMe: 'Przypisane do mnie',
                assignedToGroup: 'Przypisane do grupy',
                tookByMe: 'Podjęte przeze mnie',
                takeIssueBtn: 'Podejmij',
                arriveIssueBtn: 'Przybyłem',
                finishIssueBtn: 'Zakończ',
                history: 'Historia',
                myResponsible: 'Jestem odpowiedzialny',
            },
        },
    },
    synchronization: {
        enabled: 'Uruchomione',
        hasHeaders: 'Posiada nagłówki',
        leaveFile: 'Pozostaw plik',
        host: 'Host',
        port: 'Port',
        protocol: 'Protokół',
        username: 'Nazwa użytkownika',
        password: 'Hasło',
        root: 'Ścieżka',
        encoding: 'Kodowanie',
        separator: 'Separator',
        externalSystemId: 'ID w systemie zewnętrznym',
        cronExpression: 'Wyrażenie Cron',
        appendFullStock: 'Dołącz całość',
        includeHeaders: 'Dołącz nagłówki',
        withTrashed: 'Wraz z usuniętymi danymi',
        filePattern: 'Wzór pliku',
    },
    processes: {
        created_at: 'Data utworzenia',
        started_at: 'Data startu',
        updated_at: 'Data aktualizacji',
        finished_at: 'Data ukończenia',
        attempts: 'Ilość prób',
        queue: 'Kolejka',
        job_id: 'ID procesu',
        job_uuid: 'UUID procesu',
        progress_max: 'Progress maksymalny',
        progress_now: 'Progress obecny',
        outputMessage: 'Wiadomość',
        status: {
            queued: 'W kolejce',
            executing: 'Wykonywane',
            finished: 'Ukończone',
            failed: 'Nieudany',
            retrying: 'Ponawianie',
            undefined: 'Nieznany',
        },
    },
    weekDays: {
        mo: 'Poniedziałek',
        tu: 'Wtorek',
        we: 'Środa',
        th: 'Czwartek',
        fr: 'Piątek',
        sa: 'Sobota',
        su: 'Niedziela',
    },
    reports: {
        reports: 'Raporty',
        dateFrom: 'Data od',
        dateTo: 'Data do',
        types: {
            operation_sheet: 'Arkusz operacyjny',
            issue_summary: 'Podsumowanie zgłoszeń',
            grouped_summary: 'Raport zbiorczy',
            storage_operations: 'Operacje magazynowe',
            part_quantity_export: 'Stany magazynowe',
        },
        reportFor: 'Raport dla',
        includeQuantityLeft0: 'Uwzględnij części ze stanem zerowym',
    },
    logs: {
        comment: 'Komentarz',
        issues: {
            escalation: 'Eskalacje ({minutes} min) - wysłano powiadomienie',
        },
        issueEmployee: {
            assignedAt: 'Pracownik przypisany:',
            receivedAt: 'Pracownik odczytał:',
            tookAt: 'Pracownik podjął',
            finishedAt: 'Pracownik zakończył',
            deletedAt: 'Pracownik usunięty ze zgłoszenia',
        },
    },
    units: {
        no: 'Sztuka',
        st: 'Zestaw',
        pr: 'Para',
    },
    rrule: {
        frequency: 'Cykliczność',
        dtstart: 'Data rozpoczęcia',
        tzid: 'Strefa czasowa',
        until: 'Data zakończenia',
        count: 'Liczba powtórzeń',
        interval: 'Interwał',
        wkst: 'Dzień rozpoczęcią',
        byweekday: 'Tygodniowo',
        bymonth: 'Miesięcznie',
        yearly: 'Rocznie',
        monthly: 'Miesięcznie',
        weekly: 'Tygodniowo',
        daily: 'Dziennie',
        hourly: 'Co godzinę',
        minutely: 'Co minutę',
        secondly: 'Co sekundę',
        infinitePeriodicityMessage:
            'Cykliczność jest nieskończona, ze względu na wydajność wyświetlanych jest tylko 500 wierszy',
    },
    months: {
        jan: 'Styczeń',
        feb: 'Luty',
        mar: 'Marzec',
        apr: 'Kwiecień',
        may: 'Maj',
        jun: 'Czerwiec',
        jul: 'Lipiec',
        aug: 'Sierpień',
        sep: 'Wrzesień',
        oct: 'Październik',
        nov: 'Listopad',
        dec: 'Grudzień',
    },
    charts: {
        charts: 'Wykresy',
        count: 'Liczba zgłoszeń',
        total: 'Łączny czas zgłoszeń (od zgłoszenia do zakończenia)',
        serw: 'Łączny czas naprawy (Ttotal - Twait)',
        mttr1: 'Średni czas od zgłoszenia do zakończenia',
        mttr2: 'Średni czas od podjęcia do zakończenia',
        mtbf: 'Średni czas pomiędzy awariami',
        mttf: 'Średni czas do wystąpienia awarii',
    },
    regexBuilder: {
        regexValue: 'Wartość wyrażenia regularnego',
        global: 'Globalne',
        multiline: '^ i $ odpowiadają początkowi/końcowi linii',
        insensitive: 'Bez rozróżniania wielkości liter',
        extended: 'Ignoruj białe znaki',
        singleline: 'Kropka odpowiada nowej linii',
        unicode: 'Unicode',
        Ungreedy: 'Leniwe kwantyfikatory',
        Anchored:
            'Zakotwiczenie na początku wzorca lub na końcu ostatniego dopasowania',
        Jchanged: 'Zezwalaj na duplikaty nazw podwzorców',
        DollarEndOnly: '$ pasuje tylko do końca wzorca',
        testValue: 'Wartość testowa',
    },
    accessMergeValues: {
        sum: 'Suma',
        product: 'Iloczyn',
        overwrite: 'Nadpisz',
    },
    tpm: {
        history: 'Historia',
        standardObstacle: 'Standardowa przeszkoda',
        customObstacle: 'Niestandardowa przeszkoda',
        bhp: 'BHP',
        returnToMainPage: 'Powrót do strony głównej',
        bhpMessage:
            'Jeżeli widzisz zagrożenia bezpieczeństwa zgłoś to proszę bez zwłoki do bezpośredniego przełożonego i użyj formatki zgłoszenia która znajduje się pod tablicą ogłoszeń',
        ok: 'Ok',
        send: 'Wyślij',
        description: 'Opis',
        title: 'Tytuł',
        realization: 'Realizacja',
        answer: 'Odpowiedź',
        pendingSurveys: 'Trwające ankiety',
        surveys: 'Ankiety',
        systemSurvey: 'Ankieta systemowa',
        addPage: 'Dodaj stronę',
        createSurvey: 'Utwórz ankietę',
        addSection: 'Dodaj sekcję',
        addQuestion: 'Dodaj pytanie',
        questionContent: 'Treść pytania',
        answerOption: 'Opcja odpowiedzi',
        addQuestionAnswer: 'Dodaj opcję odpowiedzi',
        surveyName: 'Nazwa ankiety',
        sectionName: 'Nazwa sekcji',
        noSurveyAnswers: 'Brak odpowiedzi',
        removeSection: 'Usuń sekcję',
        published: 'Opublikowane',
        unpublished: 'Nieopublikowana',
        pendingPublication: 'Zmiany oczekują na publikację',
        removeQuestion: 'Usuń pytanie',
        removeAnswer: 'Usuń opcję odpowiedzi',
        publish: 'Opublikuj',
        unpublish: 'Cofnij publikacje',
        previewResults: 'Zobacz odpowiedzi',
        supervisior: 'Przełożony',
        surveyResults: 'Wyniki ankiet',
        surveysEvents: 'Konfiguracja zdarzeń - ankiety',
        operatedBy: 'Obsługiwane przez',
        confirmReadInformations: 'Zapoznałem się z informacjami',
        noticeContent: 'Treść obwieszczenia',
        notice: 'Obwieszczenie',
        surveyEventName: 'Nazwa zdarzenia',
        survey: 'Ankieta',
        newIssue: 'Nowe zgłoszenie',
        surveyEventConfigurationAlreadyExists: 'Taka konfiguracja już istnieje',
        lastComment: 'Ostatni komentarz osoby odpowiedzialnej',
        surveyNotConfigured: 'Ankieta nieskonfigurowana',
        fillSurvey: 'Uzupełnij ankietę',
        singleSurveyEntries: 'Pojedyncze rezultaty',
        groupedSurveyEntries: 'Zgrupowane rezultaty',
        publicationId: 'ID publikacji',
        publicationDate: 'Data publikacji',
        versionId: 'ID wersji',
        answersCount: 'Ilość odpowiedzi',
        answers: 'Odpowiedzi',
        withoutSupervisor: 'Bez przełożonego',
        defaultSupervisor: 'Domyślny przełożony',
        flowStateFlags: 'Flagi statusu',
        qrActionsSettings: 'Ustawienia akcji kodów QR',
        loginRequired: 'Wymaga logowania',
        questionContext: 'Kontekst pytania',
        groupableHeadersPlaceholder:
            'Przeciągnij nagłówek tabeli, aby zgrupować dane.',
        currentSurveyVersionPreview: 'Podgląd obecnej wersji ankiety',
        surveyDescription: 'Opis ankiety',
        sectionDescription: 'Opis sekcji',
        instructions: 'Instrukcje',
        instruction: 'Instrukcja',
        instructionRevisions: 'Rewizje',
        instructionRevision: 'Rewizja',
        checklists: 'Listy kontrolne',
        checklist: 'Lista kontrolna',
        checklistItem: 'Element listy',
        manageChecklistFields: 'Zarządzaj elementami listy',
        checklistItemDisplayOptions: 'Wyświetlane pozycje',
        revisionAutoRejectedInfo: '[System] Odrzucono - utworzono nową rewizję',
    },
    checklists: {
        itemBasic: 'Podstawowy element',
        itemSeparator: 'Separator',
        itemSection: 'Sekcja',
        publish: 'Opublikuj',
        previewCurrentVersion: 'Podgląd obecnej wersji',
    },
};
